import React from "react";
import { Button, Result } from "antd";
import { getValidLandingScreen } from "../../helpers/utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Unauthorised = () => {
  const history = useHistory();
  return (
    <Result
      status="403"
      title=""
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <Button
          type="primary"
          onClick={() => history.push(getValidLandingScreen())}
        >
          Back Home
        </Button>
      }
    />
  );
};
export default Unauthorised;
